import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'icon',
    templateUrl: './icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconComponent {
  @Input() icon!: string;
}
